<template>
	<div class="contain">
		<Modal @closeDialog="visible = false" :visible="visible" :errorMessage="errorMessage"></Modal>
		<h2>User Edit History</h2>
		<div class="row">
			<div class="container">
				<div class="col-md-offset-4 col-md-4 col-xs-12">
					<form>
						<div class="form-group">
							<input type="text" class="form-control" placeholder="User" v-model="user">
						</div>
						<div class="form-group">
							<input type="text" class="form-control" placeholder="Start Date (YYYY-MM-DD)" v-model="start">
						</div>
						<div class="form-group">
							<input type="text" class="form-control" placeholder="End Date (YYYY-MM-DD)" v-model="end">
						</div>
						<div class="form-group">
							<input class="form-control" placeholder="Number of results to display" v-model.number="limit" type="number">
						</div>
						<button type="button" v-on:click="getEditHistory" class="btn btn-default submit-btn">Submit</button>
					</form>
					<div v-if="loading" class="fa-3x">
						<i class="fas fa-spinner fa-spin"></i>
					</div>
				</div>
				<div id="edit_history">
					<template v-if="changes.length > 0">
						<template v-for="change in changes">
							<div class="change_row">
								<div class="change_meta">
									<div v-for="(edit_data, column) in change">
										{{ displayChangeMeta(edit_data, column, change) }}
									</div>
								</div>
								<div class="change_data">
									<div>
										<pre>{{ displayChange(change) }}</pre>
									</div>
								</div>
							</div>
						</template>
					</template>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import Modal from './shared/Modal';

export default {
	name: 'EditHistory',
	components: {
		Modal
	},
	data() {
		return {
			user: null,
			table: null,
			start: null,
			end: null,
			limit: null,
			changes: [],
			loading: false,
			visible: false,
			errorMessage: ''
		}
	},
	methods: {
		async getEditHistory() {
			this.loading = true;
			this.changes = [];

			if ( !this.user || this.user.length <= 6 ) {
				this.loading = false;
				this.visible = true,
				this.errorMessage = 'User field is required.';
				return;
			}

			let converted_user = this.user.replace(/\@/g, '_').replace(/\./g, '_').replace(/[\u0250-\ue007]/g, '');
			let query_string = '';

			if ( this.limit ) {
				query_string += `&limit=${this.limit}`;
			}
			if ( this.start ) {
				query_string += `&start=${this.start}`;
			}
			if ( this.end ) {
				query_string += `&end=${this.end}`;
			}
			if ( query_string ) {
				query_string = `?${query_string}`;
			}

			let err = '';

			let headers = {"Content-Type": "application/json"};
			headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/users/history/${converted_user}${query_string}`;

			let response = await fetch(`${process.env.VUE_APP_API4_DOMAIN}/users/authorize`, {
				method: 'GET',
				headers: headers,
				credentials: 'include'
			}).catch(function(error) {
				err = error;
			});

			this.loading = false;

			if ( err ) {
				this.visible = true,
				this.errorMessage = err;
			}
			if ( response.status == 200 ) {
				response = await response.json();
				if ( response.data[0].get_changes ) {
					this.changes = response.data[0].get_changes;
				}
				else {
					this.visible = true,
					this.errorMessage = 'No activity found for this user within the provided date range.';
				}
			}
			else {
				if ( response.status == 403 ) {
					response = await response.json();
					alert("Insufficient privileges.");
					window.location.href = '/login';
				}
				else {
					this.visible = true,
					this.errorMessage = 'An error occurred, please try again.';
				}
			}

			this.loading = false;
		},
		displayChangeMeta(col_data, col_key, change) {
			if ( col_key == 'action' ) {
				if (col_data == 'I' ) {
					col_data = 'Insert';
				}
				if (col_data == 'U' ) {
					col_data = 'Update';
				}
				if (col_data == 'D' ) {
					col_data = 'Delete';
				}
			}
			else if ( col_key == 'id' ) {
				col_data = `change ID ${change.id}`;
			}
			else if ( col_key == 'table_name' ) {
				col_data = `${change.table_name} ID ${change.row_data.id}`;
			}
			else if ( col_key == 'user_name' ) {
				col_data = this.user;
			}
			else if ( col_key == 'action_timestamp' ) {
				let t = col_data.substring(0, 19);
				t = t.replace('T', ' ');
				return t;
			}
			if ( col_key != 'changed_fields' && col_key != 'row_data' ) {
				return col_data;
			}
		},
		displayChange(change) {
			if ( change.action == 'D' ) {
				return '';
			}
			else if (change.action == 'U' ) {
				return this.castChangeDataToString(change.changed_fields);
			}
			else if (change.action == 'I' ) {
				return this.castChangeDataToString(change.row_data);
			}
		},
		castChangeDataToString(change_data) {
			let change_str = '';
			for (let [k, v] of Object.entries(change_data)) {
				change_str += `${k}: ${v}\n`;
			}
			return change_str;
		}
	}
}

</script>

<style scoped>

.contain {
	margin-top: 100px;
}
h2 {
	text-align: center;
}

form {
	margin-top: 25px;
}

.submit-btn {
	width: 100%;
	background-color: #3498DB;
	color: white;
	font-weight: 600;
}

#edit_history {
	clear: both;
	padding-top: 20px;
	width: 90%;
	margin: auto;
}

#edit_history .change_meta {
	width: 100%;
	padding-left: 9.5px;
}

#edit_history .change_meta div {
	width: 20%;
	display: inline-block;
	position: relative;
	top: 12px;
}

#edit_history .change_row {
	background: #CCC;
}

</style>
